const ascii = (bytes: Uint8Array, start: number, length: number): string =>
  String.fromCharCode(...bytes.subarray(start, start + length));

export function hasWebpSignature(bytes: Uint8Array): boolean {
  return bytes.length >= 12 && ascii(bytes, 0, 4) === 'RIFF' && ascii(bytes, 8, 4) === 'WEBP';
}

export function isAnimatedWebp(bytes: Uint8Array): boolean {
  if (!hasWebpSignature(bytes)) return false;

  let offset = 12;
  while (offset + 8 <= bytes.length) {
    const type = ascii(bytes, offset, 4);
    const view = new DataView(bytes.buffer, bytes.byteOffset + offset + 4, 4);
    const length = view.getUint32(0, true);
    if (type === 'ANIM' || type === 'ANMF') return true;
    offset += 8 + length + (length % 2);
  }
  return false;
}

export function webpLoopsIndefinitely(bytes: Uint8Array): boolean {
  if (!hasWebpSignature(bytes)) return false;

  let offset = 12;
  while (offset + 14 <= bytes.length) {
    const type = ascii(bytes, offset, 4);
    const length = new DataView(bytes.buffer, bytes.byteOffset + offset + 4, 4).getUint32(0, true);
    if (type === 'ANIM' && length >= 6) {
      return new DataView(bytes.buffer, bytes.byteOffset + offset + 12, 2).getUint16(0, true) === 0;
    }
    offset += 8 + length + (length % 2);
  }
  return false;
}
